import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface UploadIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const UploadIcon = ({ className, ...props }: UploadIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19 17L19 20L5 20L5 17"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M12 16V4M12 4L15.5 7.5M12 4L8.5 7.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export default UploadIcon;
